import { request } from "src/utils";
export const apiGetStarredTransferList = (params: {
  page?: number;
  row?: number;
  network_id?: string;
  remark?: string;
}) =>
  request({
    url: "/open/v2/starred_transfer",
    method: "GET",
    params: {
      ...params,
    },
  });

export const apiAddStarredTransfer = (params: { extrinsic_id: string; network_id: string; remark: string }) =>
  request({
    url: "/open/v2/starred_transfer",
    method: "POST",
    params: {
      ...params,
    },
  });

export const apiDeleteStarredTransfer = (params: { ids: number[] }) =>
  request({
    url: "/open/v2/starred_transfer",
    method: "DELETE",
    data: {
      ...params,
    },
  });

export const apiUpdateStarredTransfer = (params: { id: number; remark: string }) =>
  request({
    url: "/open/v2/starred_transfer",
    method: "PUT",
    data: {
      ...params,
    },
  });

export const apiDownloadStarredTransferCSV = (params: {
  network_id?: string;
  extrinsic_id?: string;
  remark?: string;
}) =>
  request({
    url: "/open/v2/starred_transfer/download",
    method: "GET",
    params: {
      ...params,
    },
  });
